import * as React from 'react';
import { RenderElementProps } from 'slate-react';
import styled from 'styled-components';

const Container = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  row-gap: 16px;

  .paragraph-toggle-element,
  .image-toggle-element {
    padding: 0;
    box-shadow: none;
  }
`;

export const MultipleChoiceQuestionItem = (props: RenderElementProps) => {
  const { children, attributes } = props;

  return (
    <Container className="multiple-choice-question-item" {...attributes}>
      {children}
    </Container>
  );
};
